import styled from '@emotion/styled';

const MDXStyledH2 = styled.h2`
  margin: 1.4rem 0 3px;
  font-size: 1.5rem;
  font-weight: 600;
`;

export default MDXStyledH2;
